export default "__VITE_ASSET__GZRM2L7W__"